<template>
  <div>
    <div class="titlePage">Configurações de testes</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <b-card-group deck>
          <b-card tag="article" style="max-width: 22rem" class="p-1">
            <b-card-text class="text-center">
              Quantidade de usuários necessários para liberar a publicação
              <fccInput
                extraClasses="inputLabel mt-3 text-center"
                v-model="qtdeMinimoTestes"
                @change="alteraParametro"
                :disabled="selecionadoMinimoTeste == null"
                type="number"
                required
              ></fccInput>
            </b-card-text>
          </b-card>
          <b-card tag="article" style="max-width: 22rem" class="p-1">
            <b-card-text class="text-center">
              Responsáveis com <br />testes efetuados
              <h3 class="mt-3">
                {{ totalTestesEfetuadas }} de
                {{ qtdeMinimoTestes }}
              </h3>
            </b-card-text>
          </b-card>
        </b-card-group>
      </div>
    </div>
    <div class="titlePage mt-4">{{ titlePage }}</div>
    <hr />
    <fccTable
      striped
      hover
      :fields="fieldsTestes"
      :orderby="sortBy"
      :actions="actionsTeste"
      addFilter
      :items="listagemResponsaveisTestes"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePDF"
    >
    </fccTable>
    <fccModal
      centered
      idModal="editResponsavel"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
      @close="abreTestesResponsavel = false"
      size="lg"
    >
      <ConfigTestesResponsavel
        :controle-testes="controleTestes"
        v-if="abreTestesResponsavel"
        :responsavelTeste="responsavelSelecionado"
        :idPublicacaoTestes="idPublicacaoTestes"
      />
    </fccModal>
    <fccModal
      centered
      idModal="addResponsavel"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
      size="lg"
    >
      <form @submit.prevent="adicionaResponsavel()" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-12">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                v-model="selected"
                :options="options"
                @change="limpaResponsavel"
                :aria-describedby="ariaDescribedby"
                name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="selected">
          <div class="col-sm-12">
            <v-select
              :options="lstFinalFuncionarios"
              v-model="funcionarioSelecionado"
              @input="funcionarioRelacionado"
              class="selectSPI"
              label="nome"
              placeholder="Selecione um funcionário"
              :clearable="false"
            >
            </v-select>
          </div>
        </div>
        <template v-if="selected != null">
          <template v-if="responsavelSelecionado.nome != null || !selected">
            <div class="row" :class="selected ? 'innerPage' : ''">
              <div class="col-sm-3">
                <fccInput
                  extraClasses="inputLabel"
                  v-model="responsavelSelecionado.cpf"
                  required
                  v-mask="cpf"
                  @change="listaCandidatosPorCPF"
                  :disabled="selected"
                  >CPF</fccInput
                >
              </div>
              <div class="col-sm-9">
                <fccInput
                  extraClasses="inputLabel"
                  v-model="responsavelSelecionado.nome"
                  required
                  disabled
                  >Nome</fccInput
                >
              </div>
            </div>
            <div class="row innerPage">
              <div class="col-sm-12">
                <fccInput
                  extraClasses="inputLabel"
                  v-model="responsavelSelecionado.email"
                  required
                  disabled
                  >E-mail</fccInput
                >
              </div>
            </div>
            <div class="row innerPage">
              <div class="col-sm-12 text-right">
                <fccButton
                  classeAdd="form-control"
                  tipo="submit"
                  :disabled="responsavelSelecionado.nome == null"
                  >{{ labelsSystem.salvar }}</fccButton
                >
              </div>
            </div>
          </template>
        </template>
      </form>
    </fccModal>
  </div>
</template>
<script>
import store from '../../../store'
import axios from 'axios'
import ConfigTestesResponsavel from './ConfigTestesResponsavel.vue'

export default {
  data() {
    return {
      selected: null,
      abreTestesResponsavel: false,
      options: [
        { text: 'Funcionário', value: true },
        { text: 'Externo', value: false }
      ],
      lstFinalFuncionarios: [],
      listaFuncionarios: [],
      responsavelSelecionado: {},
      cpf: '###.###.###-##',
      fieldsTestes: [
        { key: 'cpf', label: 'CPF', sortable: true, active: true },
        {
          key: 'nome',
          label: 'Nome',
          sortable: true,
          active: true
        },
        {
          key: 'email',
          label: 'E-mail',
          sortable: true,
          active: true
        },
        {
          key: 'qtdeteste',
          label: 'Qtde de testes',
          sortable: true,
          active: true,
          totalizar: true
        },

        { key: 'actions', label: '', active: true }
      ],
      funcionarioSelecionado: '',
      actionsTeste: [
        {
          button: true,
          funcaoButton: 'editandoTestes',
          icon: 'eye',
          tooltip: 'Visualizar testes',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deletandoTestes',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      qtdeMinimoTestes: 3,
      selecionadoMinimoTeste: null,
      totalTestesEfetuadas: 0,
      baseUrlPublicacao: '',
      sortBy: 'ordem',
      titlePage: 'Responsáveis pelos testes',
      titleModal: '',
      listagemResponsaveisTestes: [],
      titlePDF: 'Responsáveis pelos testes',
      itemPorPage: '100'
    }
  },
  components: { ConfigTestesResponsavel },
  props: {
    idPublicacaoTestes: {
      type: Number,
      required: true,
      default: 0
    },
    listaParametros: {
      type: Array,
      required: true,
      default: () => []
    },
    controleTestes: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    alteraParametro() {
      const param = {
        idpublicacaoparametro: this.selecionadoMinimoTeste.idpublicacaoparametropadrao,
        valorpublicacao: this.qtdeMinimoTestes
      }
      this.editandoParamTipoGenerico([param]).then(() => {
        this.$emit('listarTipoPublicacao')
        this.carregaTexto()
      })
    },
    limpaResponsavel() {
      this.responsavelSelecionado = {
        idresponsavelteste: 0,
        idcandidato: 0,
        idpublicacao: this.idPublicacaoTestes,
        cpf: null,
        nome: null,
        email: '',
        usuId: this.dadosUserSession.usuID
      }
      this.funcionarioSelecionado = ''
    },
    funcionarioRelacionado() {
      this.responsavelSelecionado.nome = this.funcionarioSelecionado.nome
      this.responsavelSelecionado.email = this.funcionarioSelecionado.email
      this.responsavelSelecionado.cpf = this.funcionarioSelecionado.cpf
      this.responsavelSelecionado.idcandidato = this.funcionarioSelecionado.idcandidato
    },
    editandoTestes(_, item) {
      this.titleModal = 'Testes realizados'
      this.responsavelSelecionado = item
      this.abreTestesResponsavel = true
      this.$root.$emit('bv::show::modal', 'editResponsavel')
    },
    addField() {
      this.titleModal = 'Adicionar responsável'
      this.limpaResponsavel()
      this.selected = null
      this.$root.$emit('bv::show::modal', 'addResponsavel')
    },
    capturaQtdeTestes(listaParametros) {
      if (listaParametros.length) {
        this.selecionadoMinimoTeste = listaParametros.find(
          (element) => element.codigo === 'qtde-testes-liberar-publicacao'
        )
        this.qtdeMinimoTestes =
          this.selecionadoMinimoTeste == null
            ? this.qtdeMinimoTestes
            : this.selecionadoMinimoTeste.valorpublicacao
      }
    },
    listarResponsaveis() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlPublicacao +
            'PublicacaoResponsaveisTeste/ListarPorIdPublicacao/' +
            this.idPublicacaoTestes,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemResponsaveisTestes = response.data
          if (response.data.length) {
            response.data.map((e) => {
              this.totalTestesEfetuadas = this.totalTestesEfetuadas + (e.qtdeteste > 0 ? 1 : 0)
            })
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    usuarioListandoResponsavel: function () {
      axios
        .get(
          store.state.baseUrlPublicacao + 'PublicacaoResponsaveisTeste/ListarFuncionariosTeste',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstFinalFuncionarios = response.data
        })
        .catch(this.setErrorSystem)
    },
    adicionaResponsavel() {
      this.responsavelSelecionado.cpf = this.responsavelSelecionado.cpf.replace(/[^\d]+/g, '')
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          store.state.baseUrlPublicacao + 'PublicacaoResponsaveisTeste/Inserir',
          this.responsavelSelecionado,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.$root.$emit('bv::hide::modal', 'addResponsavel')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.listarResponsaveis()
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$root.$emit('bv::hide::modal', 'addResponsavel')
            this.callAlert(error.response.data, '', 'error', 'error')
          } else {
            this.setErrorSystem()
          }
        })
        .finally(this.carregaTexto)
    },
    listaCandidatosPorCPF() {
      var cpf = this.responsavelSelecionado.cpf.replace(/[^\d]+/g, '')
      if (cpf.length === 11) {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .get(
            store.state.baseUrlConcursos + 'Candidato/ListarDadosCandidatoPorCpf/' + cpf,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            if (response.status === 204) {
              this.callAlert('CPF não encontrado', '', 'error', 'error')
            } else {
              this.responsavelSelecionado.idcandidato = response.data.idcandidato
              this.responsavelSelecionado.nome = response.data.nome
              this.responsavelSelecionado.email = response.data.email
            }
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      }
    },
    deletandoTestes(_, item) {
      this.callConfirm(this.mensagemExcluir, item.nome).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              store.state.baseUrlPublicacao +
                'PublicacaoResponsaveisTeste/Excluir/' +
                item.idresponsavelteste,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarResponsaveis()
              this.callToast(this.mensagensUpdate.excluido)
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto())
        }
      })
    }
  },
  created() {
    this.usuarioListandoResponsavel()
    this.listarResponsaveis()
    this.capturaQtdeTestes(this.listaParametros)
  }
}
</script>
